import { MutationTree } from 'vuex'
import { Contactlensname, DataState, Shopname } from './types'

export const mutations: MutationTree<DataState> = {
  setContactlenses (state, payload: Contactlensname[]) {
    state.contactlenses = payload
  },
  setShops (state, payload: Shopname[]) {
    state.shops = payload
  }
}
